module.exports = __webpack_public_path__ + "static/media/visual-block.b37ed602.svg";